var map = {
	"./decidim/avatar-multiuser.png": 1932,
	"./decidim/brands/google.svg": 75043,
	"./decidim/cc-badge.png": 70302,
	"./decidim/decidim-logo.svg": 52078,
	"./decidim/default-avatar.svg": 42138,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 18734,
	"./decidim/icons.svg": 23181,
	"./decidim/pattern.png": 71402,
	"./decidim/placeholder-card-g.svg": 49223,
	"./decidim/placeholder-card-l.svg": 90748,
	"./decidim/placeholder.jpg": 20771,
	"./decidim/remixicon.symbol.svg": 66891,
	"./decidim/vendor/leaflet/layers-2x.png": 81390,
	"./decidim/vendor/leaflet/layers.png": 92661,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 91836,
	"./decidim/vendor/leaflet/marker-icon.png": 21419,
	"./decidim/vendor/leaflet/marker-shadow.png": 97904,
	"./decidim/vendor/social-share-button/douban.svg": 27386,
	"./decidim/vendor/social-share-button/email.svg": 9463,
	"./decidim/vendor/social-share-button/facebook.svg": 9161,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 33419,
	"./decidim/vendor/social-share-button/hacker_news.svg": 68731,
	"./decidim/vendor/social-share-button/linkedin.svg": 95431,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 68736,
	"./decidim/vendor/social-share-button/pinterest.svg": 94649,
	"./decidim/vendor/social-share-button/reddit.svg": 6121,
	"./decidim/vendor/social-share-button/telegram.svg": 83760,
	"./decidim/vendor/social-share-button/tumblr.svg": 15559,
	"./decidim/vendor/social-share-button/twitter.svg": 76262,
	"./decidim/vendor/social-share-button/vkontakte.svg": 62712,
	"./decidim/vendor/social-share-button/wechat.svg": 82179,
	"./decidim/vendor/social-share-button/whatsapp.svg": 25595,
	"./decidim/vendor/social-share-button/x.svg": 55823,
	"./decidim/vendor/social-share-button/xing.svg": 42217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78801;